import React from 'react'

const FilterIcon = ({color="white"}:{color?:string}) => {
    return (
        <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 5.82031V4.17969H13V5.82031H3ZM0.5 0H15.5V1.67969H0.5V0ZM6.32031 10V8.32031H9.67969V10H6.32031Z" fill={color}/>
        </svg>
    )
}

export default FilterIcon